import { PERMISSIONS } from '../../constants';
import { ChangeLogIcon, ChangeLogList } from './ChangeLogList';

export default {
  list: ChangeLogList,
  icon: ChangeLogIcon,
  name: 'change-log',
  permissions: [PERMISSIONS.ADMIN],
  options: { label: 'Histórico de Alterações' },
  hasShow: false,
  hasEdit: false,
};
